import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import ContactSection from '../../components/ContactSection';
import Journey from '../../components/journey/journey';


const ContactPage = (props) => {

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>We are the go-to choice for <br/> small property owners.</h1>
                                    <br/>
                                    <p className='mb-0'>That’s why every hour another property owner chooses to partner with us.</p>
                                </div>
                            </div>
                        </div>
                </section>
                {/* <PageTitle pageTitle={'Contact Us'} pagesub={'Us 😍'} pageTop={'Contact'} /> */}
                <ContactSection />
                <Journey />
                {/* <CtaSection /> */}
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ContactPage;